import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { ICogs, IParamsGetCogs, IResponseGetCogs } from '~/utils/interface/cogs';

const url = `api/admin/cogs`;

const cogsApi = {
  create(data: ICogs) {
    return axiosClient.post<IApiBaseResponse<ICogs>>(url, data);
  },
  getList(params: IParamsGetCogs) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCogs>>(`api/admin/cogs`, { params });
  },

  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<ICogs>>(`api/admin/cogs/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: ICogs) {
    return axiosClient.put<IApiBaseResponse<ICogs>>(`api/admin/cogs/${id}`, data);
  },
};

export default cogsApi;
